<template>
  <div>
    <h1>Email diary</h1>
    <v-data-table
      v-if="computedEmails"
      :headers="headers"
      :items="computedEmails"
      :pagination.sync="pagination"
      class="elevation-1"
    >
      <template v-slot:items="props">
        <tr>
          <td>
            <router-link
              small
              :to="{
                name: 'fileEmails',
                params: { id: props.item.file.id },
                query: { id: props.item.id },
              }"
              v-if="props.item.file"
              >{{ props.item.file.reference }}
            </router-link>
          </td>
          <!-- <td>
            <FileZ :file="props.item.file" v-if="props.item.file" />
          </td> -->
          <td>{{ props.item.subject }}</td>
          <td>{{ props.item.attachmentCount }}</td>
          <td>{{ props.item.sent | formatTime }}</td>
        </tr>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import nbmlaw from "@/api/nbmlaw";
export default {
  name: "Diary",
  computed: {
    computedEmails() {
      if (!this.diary) {
        return undefined;
      }
      return this.diary.emails.map((e) => {
        const file = this.diary.files[e.id];
        return { ...e, file };
      });
    },
  },
  data() {
    return {
      diary: null,
      headers: [
        {
          text: "Id",
          value: "id",
        },
        {
          text: "Subject",
          value: "subject",
        },
        {
          text: "Attachments",
          value: "attachmentCount",
        },
        {
          text: "Sent",
          value: "sent",
        },
      ],
      pagination: {
        rowsPerPage: -1,
      },
    };
  },
  methods: {
    async fetchDiary() {
      const response = await nbmlaw.get(`/cors/admin/email/emails/diary`, {
        params: { date: this.$route.query.date },
      });
      // console.log(response.data);
      this.diary = response.data;
    },
  },
  watch: {
    "$route.query.date": {
      immediate: true,
      handler() {
        this.fetchDiary();
      },
    },
  },
};
</script>